import { Stack } from '@mui/material';
import AuthSection from './AuthSection';
import EquipmentDetails from './EquipmentDetails';
import Header from './Header';
import InventoryDetails from './InventoryDetails';
import TagChips from './TagChips';
import PropTypes from 'prop-types';

const EquipmentOption = ({ option, optionRef, fieldName, searchTerm }) => {
    if (!option) return null;

    const { inventoryItemType, inventoryStatus, accessEquipments, equipmentCategory, company, vinNumber, licencePlate, equipmentAlerts, isRecent } =
        option;

    const inventoryName = inventoryItemType?.name;
    const fieldValue = option[fieldName];

    const personnelNames = option?.personnelList?.map((p) => p.name) || [];
    const gateNames = option?.gateList?.map((g) => g.name || g) || [];

    const equipmentStatus = accessEquipments?.[0]?.equipmentStatus;

    return (
        <Stack spacing={0.15}>
            <Header headerName={fieldValue} optionRef={optionRef} alerts={equipmentAlerts} isRecent={isRecent} searchTerm={searchTerm} />
            <TagChips showEquipment={!!equipmentCategory} showInventory={!!inventoryName} />

            <EquipmentDetails
                equipmentCategory={equipmentCategory}
                vinNumber={vinNumber}
                licencePlate={licencePlate}
                equipmentStatus={equipmentStatus}
                company={company}
                searchTerm={searchTerm}
            />

            {(personnelNames.length > 0 || gateNames.length > 0) && (
                <AuthSection personnelNames={personnelNames} gateNames={gateNames} searchTerm={searchTerm} />
            )}

            {inventoryName && (
                <InventoryDetails
                    inventoryValue={fieldValue}
                    inventoryName={inventoryName}
                    fieldName={fieldName}
                    inventoryStatus={inventoryStatus}
                    searchTerm={searchTerm}
                />
            )}
        </Stack>
    );
};

EquipmentOption.propTypes = {
    option: PropTypes.object,
    optionRef: PropTypes.object,
    fieldName: PropTypes.string,
    searchTerm: PropTypes.string,
};

export default EquipmentOption;
